import React from 'react';
import {Swiper, SwiperItem} from '@tarojs/components'
import styled from "styled-components";
const SwiperWrapper = styled.div<{
  objectFit: string;
  boxShadow: string;
  borderRadius: string;
}>`
  height: 100%;
  overflow: hidden;
  border-radius: ${({borderRadius})=> borderRadius};
  box-shadow: ${({boxShadow})=> boxShadow};
  img{
    width: 100%;
    height: 100%;
    object-fit: ${({objectFit})=> objectFit};
  }
  taro-swiper-core{
    height: 100%;
  }
`;
const TSwiperWidget = (props:any) => {
  const {
    imageData,
    isAutoplay,
    isCircular,
    isIndicatorDots,
    objectFit,
    onItemClick,
    borderRadius,
    boxShadow
  } = props;
  return (
    <SwiperWrapper
      objectFit={objectFit}
      borderRadius={borderRadius}
      boxShadow={boxShadow}
    >
      { imageData&&imageData.length>0?(<Swiper
        indicatorColor='#999'
        indicatorActiveColor='#333'
        circular={isCircular}
        indicatorDots={isIndicatorDots}
        autoplay={isAutoplay}>
        {
          imageData.map((i:any)=>{
            return (
              <SwiperItem>
                <img onClick={()=>{
                  onItemClick&&onItemClick(i);
                }} src={i.url} alt="" />
              </SwiperItem>
            )
          })
        }

      </Swiper>):(
        <div>请在属性栏编辑数据</div>
      ) }
    </SwiperWrapper>
  );
};

export default TSwiperWidget;
